var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 121",
    className: "w-[120px] h-[120px] shrink-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#offlineAccess_svg__a)",
    d: "M63.66 13.218c22.251 7.935 37.792 62.865 26.67 79.987-11.122 17.122-70.502-.364-80.767-14.935C-.702 63.7 41.409 5.28 63.659 13.218Z",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#offlineAccess_svg__b)",
    d: "M39.072 23.236C59.619 18.349 98.02 51.962 98.02 70.214c0 18.253-53.033 34.061-67.825 28.137-14.791-5.924-11.67-70.227 8.877-75.115Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.999 68.089h-1.667V56.422a5 5 0 0 0-5-5H47.665a5 5 0 0 0-5 5V68.09H41a1.666 1.666 0 0 0-1.667 1.667v3.333a5 5 0 0 0 5 5h23.333a5 5 0 0 0 5-5v-3.333A1.666 1.666 0 0 0 71 68.089Zm-25-11.667a1.666 1.666 0 0 1 1.666-1.666h16.667a1.666 1.666 0 0 1 1.667 1.666V68.09h-20V56.422ZM69.332 73.09a1.667 1.667 0 0 1-1.667 1.667H44.332a1.667 1.667 0 0 1-1.667-1.667v-1.667h26.667v1.667Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "offlineAccess_svg__a",
    x1: 83.124,
    x2: 36.29,
    y1: 25.221,
    y2: 97.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0720A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2229D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "offlineAccess_svg__b",
    x1: 59.51,
    x2: 59.51,
    y1: 99.616,
    y2: -7.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.6bc27464c7cc501d3b2025b9cbae9ecd.svg";
export { ForwardRef as ReactComponent };